import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
const CopyableText = ({ text, className }) => {
    const [copied, setCopied] = useState(false);
    const handleCopy = () => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };
    return (_jsx("div", { className: `cursor-pointer select-none text-gray-700  hover:text-black transition`, onClick: handleCopy, children: _jsx("span", { className: className, children: copied ? 'Copied' : text }) }));
};
export default CopyableText;
